import { ChevronLeft, ChevronRight } from "lucide-react";
import { storeName } from "../lib/labels";

/** Phone-only strip: shows which store is in view and lets you tap or swipe between them. */
export default function StoreSwiper({ outlets, outletIds, onChange }) {
  if (!outlets?.length) return null;
  const stops = [{ id: null, label: outlets.length === 1 ? storeName(outlets[0].name) : "All stores" }, ...outlets.map((o) => ({ id: o.id, label: storeName(o.name) }))];
  const currentIdx = outletIds.length === 1 ? Math.max(0, stops.findIndex((s) => s.id === outletIds[0])) : 0;
  const go = (i) => {
    const next = (i + stops.length) % stops.length;
    onChange(stops[next].id ? [stops[next].id] : []);
  };
  if (stops.length <= 2) return null;
  return (
    <div className="md:hidden flex items-center justify-between gap-2 border border-[#0a0a0a] bg-[#0a0a0a] text-[#f5f2eb] px-1" data-testid="store-swiper">
      <button onClick={() => go(currentIdx - 1)} aria-label="Previous store" data-testid="store-swiper-prev" className="w-11 h-11 flex items-center justify-center">
        <ChevronLeft size={18} />
      </button>
      <div className="flex-1 text-center min-w-0">
        <div className="font-mono-bm text-sm font-semibold truncate" data-testid="store-swiper-label">{stops[currentIdx].label}</div>
        <div className="flex items-center justify-center gap-1.5 mt-1" aria-hidden="true">
          {stops.map((s, i) => (
            <span key={s.id || "all"} className={`block h-1.5 rounded-full transition-all ${i === currentIdx ? "w-4 bg-[#c72c2c]" : "w-1.5 bg-[#f5f2eb]/40"}`} />
          ))}
        </div>
        <div className="bm-eyebrow opacity-60 mt-1 !text-[9px]">swipe to switch store</div>
      </div>
      <button onClick={() => go(currentIdx + 1)} aria-label="Next store" data-testid="store-swiper-next" className="w-11 h-11 flex items-center justify-center">
        <ChevronRight size={18} />
      </button>
    </div>
  );
}
